import { ISubTab } from './SubTab.interfaces';
import SubTab from './SubTab';

export default SubTab as any as any as React.StatelessComponent<ISubTab>;
